import React, { useState } from 'react'
import { Switch, makeStyles, withStyles } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
    switch({ lockIcons }) {
        return {
            marginBottom: -6,
            padding: 8,

            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                backgroundColor: '#4d4d4d'
            },
            '& .MuiIconButton-label': {},
            '& .MuiSwitch-track': {
                borderRadius: 22 / 2,
                height: 18,
                '&:before, &:after': {
                    content: '""',
                    position: 'absolute',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    width: 16,
                    height: 16
                },
                '&:before': lockIcons
                    ? {
                          backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="14" width="14" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
                              theme.palette.getContrastText(
                                  theme.palette.primary.main
                              )
                          )}" d="M12,17C10.89,17 10,16.1 10,15C10,13.89 10.89,13 12,13A2,2 0 0,1 14,15A2,2 0 0,1 12,17M18,20V10H6V20H18M18,8A2,2 0 0,1 20,10V20A2,2 0 0,1 18,22H6C4.89,22 4,21.1 4,20V10C4,8.89 4.89,8 6,8H7V6A5,5 0 0,1 12,1A5,5 0 0,1 17,6V8H18M12,3A3,3 0 0,0 9,6V8H15V6A3,3 0 0,0 12,3Z" /></svg>')`,
                          backgroundRepeat: 'no-repeat',
                          left: 12
                      }
                    : null,

                '&:after': lockIcons
                    ? {
                          backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="14" width="14" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
                              theme.palette.getContrastText(
                                  theme.palette.primary.main
                              )
                          )}" d="M18,20V10H6V20H18M18,8A2,2 0 0,1 20,10V20A2,2 0 0,1 18,22H6C4.89,22 4,21.1 4,20V10A2,2 0 0,1 6,8H15V6A3,3 0 0,0 12,3A3,3 0 0,0 9,6H7A5,5 0 0,1 12,1A5,5 0 0,1 17,6V8H18M12,17A2,2 0 0,1 10,15A2,2 0 0,1 12,13A2,2 0 0,1 14,15A2,2 0 0,1 12,17Z" /></svg>')`,
                          backgroundRepeat: 'no-repeat',
                          right: 12
                      }
                    : null
            },
            '& .MuiSwitch-thumb': {
                backgroundColor: '#4d4d4d',
                boxShadow: 'none',
                width: 20,
                height: 20,
                // margin: 1,
                marginTop: -2
            }
        }
    }
}))

export function CustomSwitch({
    isChecked = false,
    handleChange = null,
    lockIcons = false,
    disabled = false
}) {
    const classes = useStyles({ lockIcons })
    const [value, setValue] = useState(isChecked)

    const onChange = () => {
        setValue(!value)
        handleChange?.(!value)
    }

    return (
        <Switch
            className={classes.switch}
            checked={value}
            onChange={onChange}
            disabled={disabled}
        />
    )
}

export const CustomSwitch2 = withStyles(theme => ({
    root: {
        width: 44,
        height: 26,
        padding: 0,
        display: 'flex'
    },
    switchBase: {
        padding: 2,
        color: theme.quaternary,
        '&$checked': {
            transform: 'translateX(18px)',
            color: theme.background,
            '& + $track': {
                opacity: 1,
                backgroundColor: theme.primary,
                borderColor: theme.primary
            }
        },
        '&$disabled': {
            color: '#bdbdbd',
            '& + $track': {
                opacity: 0.5,
                backgroundColor: '#f5f5f5',
                borderColor: '#e0e0e0'
            }
        },
        '&$checked$disabled': {
            color: '#bdbdbd',
            '& + $track': {
                opacity: 0.5,
                backgroundColor: '#e0e0e0',
                borderColor: '#e0e0e0'
            }
        }
    },
    thumb: {
        width: 22,
        height: 22,
        boxShadow: 'none'
    },
    track: {
        border: `1px solid ${theme.quaternary}`,
        borderRadius: 26 / 2,
        opacity: 1,
        backgroundColor: theme.background
    },
    checked: {},
    disabled: {}
}))(Switch)
